export default __webpack_public_path__ + "static/media/bg.10ee1ee1.png";